<template>
  <div class="home" @click="clickHide">
    <div class="sticky-footer">
      <div class="header wrap" id="header" :class="darkHeader">
        <!-- <script src="https://www.google.com/recaptcha/api.js"></script> -->

        <div class="header-footer-container container-fluid">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle collapsed pull-left"
              data-toggle="collapse"
              @click.stop="clickShow"
              data-target="#sincerely-navbar-collapse"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>

            <a
              class="navbar-brand sincerely-logo"
              data-toggle="collapse"
              data-target="#sincerely-navbar-collapse"
              href="javascript:;"
            >
              <!-- <img
                src="https://d1i3miknt7yreb.cloudfront.net/sincerely/us/images/sincerely_logo_white.png"
            /> -->
              <h1 class="title">Slime Simulator</h1>
            </a>
          </div>

          <div
            class="collapse navbar-collapse"
            v-if="showLinks"
            id="sincerely-navbar-collapse"
          >
            <ul class="nav navbar-nav navbar-right">
              <li
                data-toggle="collapse"
                data-target="#sincerely-navbar-collapse"
              >
                <router-link to="/privacy-policy">Privacy</router-link>
              </li>
              <li
                data-toggle="collapse"
                data-target="#sincerely-navbar-collapse"
              >
                <router-link to="/terms-of-service">Terms</router-link>
              </li>
              <li
                data-toggle="collapse"
                data-target="#sincerely-navbar-collapse"
              >
                <router-link to="/Support">Support</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="wrap">
        <div class="home" id="home-section">
          <!-- Ink -->
          <section class="ink" id="ink-section" :class="mobileHeight">
            <div class="description" id="ink-description">
              <div class="description-container">
                <div class="responsive-phone-photo">
                  <img
                    alt="Ink Cards mobile banner for iPhone X"
                    title="Ink Cards"
                    src="@/assets/image2/ink_iphone_x_banner.png"
                  />
                </div>
                <div class="card-photo">
                  <img
                    alt="Ink Cards App personalized layout example"
                    title="Ink Cards"
                    id="ink-card-img"
                    src="@/assets/image2/ink_card_photo.png"
                  />
                </div>

                <div class="app-copy">
                  <a href="javascript:;">
                    <div class="logo">
                      <!-- <img
                        alt="Ink Cards Logo"
                        title="Ink Cards by Sincerely Inc."
                        src="@/assets/image2_cards_logo.svg"
                      /> -->
                      <h2>Get Relaxed</h2>
                    </div>

                    <div class="slogan">
                      <h1>
                        The realistic and colorful slime simulator with anti
                        stress ASMR sounds.
                      </h1>
                      <!-- <h1>one-of-a-kind greeting cards.</h1> -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="phone-container">
              <div class="image-container">
                <img src="@/assets/image2/ink_phone_x.png" />
              </div>
            </div>

            <div
              class="secondary-container"
              id="ink-envelope"
              v-show="!hideEnvelope"
            >
              <div class="image-container">
                <div class="envelope-photo">
                  <img src="@/assets/image2/ink_envelope.png" />
                </div>
              </div>
            </div>
          </section>
          <!-- END Ink -->

          <!-- Postagram -->
          <section
            class="postagram"
            id="postagram-section"
            :class="mobileHeight"
          >
            <div class="description" id="postagram-description">
              <div class="description-container">
                <div class="responsive-phone-photo">
                  <img
                    alt="Postagram mobile banner for iPhone X"
                    title="Postagram"
                    src="@/assets/image2/postagram_iphone_x_banner.png"
                  />
                </div>

                <div class="card-photo">
                  <img
                    id="postagram-card-img"
                    src="@/assets/image2/postagram_card.png"
                    alt="Postagram App personalized custom card example"
                  />
                  <img
                    id="postagram-cutout-img"
                    src="@/assets/image2/postagram_cutout.png"
                    alt="Postagram App personal photo pop out of postcard"
                  />
                </div>

                <div class="app-copy">
                  <a
                    href="http://sincerely-dev.freeprintsweb.planetart.com/postagram"
                  >
                    <div class="logo">
                      <!-- <img
                        alt="Postagram Logo"
                        title="Postagram by Sincerely Inc."
                        src="@/assets/image2_logo.svg"
                      /> -->
                      <h2>Tap Your Stress Away</h2>
                    </div>

                    <div class="slogan">
                      <h1>
                        Perfect distraction to escape the dullness of reality
                        and dive into a sensory paradise.
                      </h1>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div class="phone-container">
              <div class="image-container">
                <img
                  src="@/assets/image2/postagram_phone_x.png"
                  alt="postagram app card personalization shown on iphone x"
                />
              </div>
            </div>

            <div
              class="secondary-container"
              id="postagram-envelope"
              v-show="!hideEnvelope"
            ></div>
          </section>
          <!-- END Postagram -->
        </div>
      </div>
    </div>
    <Footer v-if="showFooter" />
  </div>
</template>

<script>
// import Banner from "@/components/Banner/Banner";
// import ScrollMagic from "scrollmagic";
// import { TweenMax } from "gsap";
import Footer from "@/components/Footer/Footer";
export default {
  name: "Home",
  components: {
    Footer
  },
  data() {
    return {
      showLinks: false,
      mobileHeight: "",
      hideEnvelope: false,
      darkHeader: "",
      setDarkHeader: null,
      showFooter: true,
      statesToShowHeader: [
        "sy.index",
        "sy.ink",
        "sy.postagram",
        "sy.about",
        "sy.faq",
        "sincerely.mobileonly"
      ]
    };
  },
  methods: {
    clickShow() {
      this.showLinks = !this.showLinks;
    },
    clickHide() {
      this.showLinks = false;
    },
    isMobile() {
      var navAgent = navigator.userAgent || navigator.vendor || window.opera;
      return (
        /(android|bb\d+|meego).+mobile|android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          navAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
          navAgent.substr(0, 4)
        )
      );
    },
    setScrollOffset() {
      var sy_index = 1;
      return sy_index ? 200 : 10;
    },
    checkState() {
      if (this.setDarkHeader) {
        this.setDarkHeader.destroy(true);
      }

      var current_route = "sy.index";

      if (this.statesToShowHeader.indexOf(current_route) > -1) {
        this.darkHeader = "";
        this.setDarkHeader = new window.ScrollMagic.Scene({
          offset: this.setScrollOffset()
        })
          .setClassToggle("#header", "dark-header")
          .addTo(new window.ScrollMagic.Controller());
      } else {
        this.darkHeader = "dark-header";
      }
    }
  },
  mounted() {
    this.showFooter = window.screen.availWidth >= 768;
    setTimeout(() => {
      this.checkState();

      var controller = new window.ScrollMagic.Controller();

      window.addEventListener("resize", function () {
        if (this.innerWidth < 769) {
          controller.enabled(false);
        } else if (!controller.enabled()) {
          controller.enabled(true);
          controller.update(true);
        }
      });

      if (this.isMobile() && controller.enabled()) {
        controller.enabled(false);
        this.mobileHeight = "mobile-height";
        this.hideEnvelope = true;
      } else {
        var pgDiecutTimeline = new window.TimelineMax()
          .add(
            window.TweenMax.to("#postagram-card-img", 1, {
              className: "+=large"
            })
          )
          .add(
            window.TweenMax.to("#postagram-cutout-img", 1, {
              className: "+=large"
            }),
            "-=1"
          )
          .add(
            window.TweenMax.to("#postagram-cutout-img", 1, {
              className: "+=popout"
            }),
            "+=0.5"
          );

        new window.ScrollMagic.Scene({ duration: 700 })
          .setPin("#ink-envelope")
          .addTo(controller);

        new window.ScrollMagic.Scene({
          triggerElement: "#ink-section",
          duration: 700,
          triggerHook: 0
        })
          .setPin("#ink-description", { pushFollowers: false })
          .addTo(controller);

        var inkCardTween = new window.TweenMax.to("#ink-card-img", 1, {
          className: "+=large"
        });
        new window.ScrollMagic.Scene({
          triggerElement: "#ink-section",
          duration: 700,
          offset: 800
        })
          .setTween(inkCardTween)
          .addTo(controller);

        new window.ScrollMagic.Scene({
          triggerElement: "#postagram-section",
          duration: 750,
          triggerHook: 0.3,
          offset: 200
        })
          .setPin("#postagram-description", { pushFollowers: false })
          .addTo(controller);

        new window.ScrollMagic.Scene({
          triggerElement: "#postagram-section",
          duration: 800,
          offset: 500
        })
          .setTween(pgDiecutTimeline)
          .addTo(controller);

        controller.enabled(true);
      }
    }, 200);
  }
};
</script>

<style scoped>
.title {
  color: #fff;
  font-size: 36px;
  margin: 0;
}
</style>
